import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Container, Row, Col } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons/faQuestionCircle';
import { connect, ConnectedProps } from "react-redux";
import { RootState } from "store";
import { layoutActions } from "store/layout";

const mapState = (state: RootState) => ({
    modal: state.layoutSlice.confirmationModal,
});

const mapDispatch = {
    closeModal: layoutActions.hideConfirmation,
};

const connector = connect(mapState, mapDispatch);
type Props = ConnectedProps<typeof connector>;

const ConfirmationDialog: React.FC<Props> = ({ modal, closeModal }) => {
    return (
        <Modal zIndex={2100} isOpen={modal.isOpen} centered>
            <ModalHeader>{modal.title}</ModalHeader>
            <ModalBody>
                <Container>
                    <Row>
                        <Col sm={3}>
                            <FontAwesomeIcon size="3x" icon={faQuestionCircle} />
                        </Col>
                        <Col sm={9}>{modal.message}</Col>
                    </Row>
                </Container>
            </ModalBody>
            <ModalFooter>
                <Button onClick={() => closeModal(true)}>Yes</Button>
                <Button onClick={() => closeModal(false)}>No</Button>
            </ModalFooter>
        </Modal>
    );
};

export default connector(ConfirmationDialog);